import fetchUserMailboxInfoFromFolderId from './fetchUserMailboxInfoFromFolderId';
import type { MailboxInfo } from 'owa-client-types';
import { isPublicFolder } from 'owa-folders';
import { getGroupIdFromTableQuery, getGroupMailboxInfoFromTableQuery } from 'owa-group-utils';
import type { TableQuery, TableView } from 'owa-mail-list-store';
import {
    getStore as getListViewStore,
    isCopilotResultsTable,
    isMyOutlookTable,
} from 'owa-mail-list-store';
import type { CopilotResultsTableQuery } from 'owa-mail-list-store/lib/store/schema/CopilotResultsTableQuery';
import type { MyOutlookTableQuery } from 'owa-mail-list-store/lib/store/schema/MyOutlookTableQuery';
import { getPublicFolderMailboxInfo } from 'owa-publicfolder-utils';
import type MailboxRequestOptions from 'owa-service/lib/MailboxRequestOptions';
import { getGlobalSettingsAccountMailboxInfo } from 'owa-account-source-list-store';

export default function getMailboxInfo(tableView: TableView | undefined): MailboxInfo {
    if (tableView) {
        return getMailboxInfoFromTableQuery(tableView.tableQuery);
    }
    return getGlobalSettingsAccountMailboxInfo();
}

export function getMailboxInfoFromTableViewId(tableViewId: string): MailboxInfo {
    const tableView = getListViewStore().tableViews.get(tableViewId);
    return getMailboxInfo(tableView);
}

export function getMailboxInfoFromTableQuery(tableQuery: TableQuery): MailboxInfo {
    // CopilotResultsTableQuery stores its account in a dedicated mailboxInfo field because
    // its folderId is a fixed placeholder string ('CopilotResultsFolder') that is not
    // account-specific and cannot be resolved via the folder store.
    if (isCopilotResultsTable(tableQuery)) {
        return (tableQuery as CopilotResultsTableQuery).mailboxInfo;
    }

    if (isMyOutlookTable(tableQuery)) {
        return (tableQuery as MyOutlookTableQuery).mailboxInfo;
    }

    const groupId = getGroupIdFromTableQuery(tableQuery);
    const folderId = tableQuery?.folderId;

    return groupId != null
        ? getGroupMailboxInfoFromTableQuery(groupId, tableQuery)
        : getMailboxInfoFromFolderId(folderId);
}

export function getMailboxInfoFromFolderId(folderId: string | null | undefined): MailboxInfo {
    if (isPublicFolder(folderId)) {
        return getPublicFolderMailboxInfo(folderId);
    } else {
        return fetchUserMailboxInfoFromFolderId(folderId);
    }
}

export function getMailboxRequestOptionsFromTableQuery(
    tableQuery: TableQuery
): MailboxRequestOptions {
    const mailboxInfo = getMailboxInfoFromTableQuery(tableQuery);
    return {
        mailboxInfo,
    };
}
